import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jinjiyoujian",
  "use": "icon-jinjiyoujian-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jinjiyoujian\">\r\n    <path d=\"M13.214 9.354C13.214 8.69 12.852 7.222 12.066 5.738C12.052 6.234 11.65 7.436 11.354 7.756C11.156 7.196 11.106 3.458 6.17599 2.2C6.47599 5.918 2.77399 5.864 2.77399 9.876C2.77399 12.008 4.05199 13.842 5.88199 14.656C5.46399 12.196 7.89399 11.88 7.50199 9.346C10.062 10.878 10.664 12.67 9.97199 14.712C12.016 13.856 13.378 11.714 13.214 9.354Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol